import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Grid,
  TextField,
  Select,
  MenuItem,
  Typography,
} from "@mui/material";
import { observer } from "mobx-react-lite";
import { useCustDiagStore } from "../../../contexts/RootStoreProvider";

const ResolutionForm = (props: any) => {
  const style = { backgroundColor: "#001f3d", color: "white" };

  const custDiagStore = useCustDiagStore();

  function handleChange(e: any) {
    switch (e.target.id) {
      case "firstName":
        custDiagStore.currentCustDiag.firstName = e.target.value;
        break;
      case "lastName":
        custDiagStore.currentCustDiag.lastName = e.target.value;
        break;
      case "email":
        custDiagStore.currentCustDiag.email = e.target.value;
        break;
      case "phone":
        custDiagStore.currentCustDiag.phone = e.target.value;
        break;
      default:
    }
  }

  function handleTitleChange(e: any, d: any) {
    custDiagStore.currentCustDiag.title = d.props.children;
  }

  function checkIfValid() {
    if (
      custDiagStore.currentCustDiag.title !== undefined &&
      custDiagStore.currentCustDiag.firstName !== undefined &&
      custDiagStore.currentCustDiag.phone !== undefined &&
      custDiagStore.currentCustDiag.email !== undefined
    ) {
      return true;
    } else {
      return false;
    }
  }

  async function handleGotoResolution(e: any) {
    if (checkIfValid()) {
      await custDiagStore.createCustomerDiagnosis();
    } else {
      alert("Please fill in the missing fields to continue!");
    }
  }

  return (
    <>
      <Grid container spacing={2} style={style}>
        <Grid item xs={12} md={12} padding={1}>
          <Typography variant="h4">
            Please enter your details to receive your diagnosis.
          </Typography>
        </Grid>
        <Grid item xs={12} md={12} padding={1}>
          <Typography gutterBottom variant="h6">
            You will be provided with a possible diagnosis of your problem and
            or a self-fix suggesion, tips, suggestions and advice on what to do
            next.
          </Typography>
        </Grid>
        <Grid item xs={12} md={12} padding={1}>
          <Select
            onChange={handleTitleChange}
            fullWidth
            defaultValue={0}
            style={{ backgroundColor: "white" }}
          >
            <MenuItem value={0}>Select Title</MenuItem>
            <MenuItem value={1}>Mr</MenuItem>
            <MenuItem value={2}>Mrs</MenuItem>
            <MenuItem value={3}>Miss</MenuItem>
          </Select>
        </Grid>

        <Grid item xs={12} md={6} padding={1}>
          <TextField
            fullWidth
            id="firstName"
            name="firstName"
            label="First Name"
            onChange={handleChange}
            style={{ backgroundColor: "white" }}
          />
        </Grid>
        <Grid item xs={12} md={6} padding={1}>
          <TextField
            fullWidth
            id="lastName"
            name="lastName"
            label="Last Name"
            onChange={handleChange}
            style={{ backgroundColor: "white" }}
          />
        </Grid>
        <Grid item xs={12} md={12} padding={1}>
          <TextField
            fullWidth
            id="email"
            name="email"
            label="Email"
            onChange={handleChange}
            style={{ backgroundColor: "white" }}
          />
        </Grid>
        <Grid item xs={12} md={12} padding={1}>
          <TextField
            fullWidth
            id="phone"
            name="phone"
            label="Phone"
            onChange={handleChange}
            style={{ backgroundColor: "white" }}
          />
        </Grid>
        <Grid item xs={12} md={12} padding={1}>
          <Button
            onClick={handleGotoResolution}
            size="large"
            color="primary"
            variant="contained"
          >
            Get my resolution
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

ResolutionForm.propTypes = {};

export default observer(ResolutionForm);
